import { jsx } from "react/jsx-runtime";
import { forwardRef } from "react";
export default forwardRef((props, ref) => jsx("svg", {
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 -0.5 21 21",
    ref,
    ...props,
    dangerouslySetInnerHTML: { __html: '<path d="M10.6 3.958 4.558 6.667s-.625 9.375 6.042 9.375c6.666 0 6.041-9.375 6.041-9.375L10.6 3.958ZM7.948 10h5.303M10.6 12.652V7.348" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />' }
  })
);